// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bLC7ZjPR{box-shadow:0 2px 3px -2px var(--theme-shadow-panel);flex:0 0 auto;flex-direction:column;font-size:var(--font-size-small);z-index:2}.bLC7ZjPR:not([hidden]){display:flex}`, "",{"version":3,"sources":["webpack://./src/page-components/app/shell/CanvasChrome.module.scss"],"names":[],"mappings":"AAAA,UACE,mDAAA,CACA,aAAA,CACA,qBAAA,CACA,gCAAA,CACA,SAAA,CAEA,wBACE,YAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chrome": `bLC7ZjPR`
};
export default ___CSS_LOADER_EXPORT___;
